// extracted by mini-css-extract-plugin
export default {"logo":"carPlusLogo_logo__v4+CP"};